export const environment = {
  accountsUrl: 'https://api.v1.simplygenie.net',
   production: true
};
